import React from 'react'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import './flower.css'

const FLOWER = (props) => {
  return (
    <div className="flower-container1">
      <Helmet>
        <title>FLOWER - Cons Menu</title>
        <meta property="og:title" content="FLOWER - Cons Menu" />
        <link
          rel="canonical"
          href="https://pristine-impeccable-rook-jpkikh.teleporthq.app/flower"
        />
        <meta
          property="og:url"
          content="https://pristine-impeccable-rook-jpkikh.teleporthq.app/flower"
        />
      </Helmet>
      <div
        aria-hidden="true"
        className="flower-thq-decorative-curves-container-elm"
      >
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-curve-elm1 curve"
        >
          <path
            d="M0,400 C360,200 720,600 1080,350 S1440,500 1440,400"
            fill="none"
            stroke="rgba(255, 255, 255, 0.08)"
            strokeWidth="2"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-curve-elm2 curve"
        >
          <path
            d="M0,200 C480,100 960,500 1440,300"
            fill="none"
            stroke="rgba(255, 255, 250, 0.06)"
            strokeWidth="1.5"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-curve-elm3 curve"
        >
          <path
            d="M0,600 C400,700 800,400 1440,550"
            fill="none"
            stroke="rgba(255, 255, 245, 0.05)"
            strokeWidth="3"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-curve-elm4 curve"
        >
          <path
            d="M1440,100 C1080,300 720,100 360,250 S0,150 0,300"
            fill="none"
            stroke="rgba(255, 255, 255, 0.07)"
            strokeWidth="2"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-curve-elm5 curve"
        >
          <path
            d="M0,700 C360,600 720,750 1080,650 S1440,700 1440,600"
            fill="none"
            stroke="rgba(255, 255, 248, 0.04)"
            strokeWidth="2.5"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-thq-curve-elm6-elm curve"
        >
          <path
            d="M0,350 Q360,150 720,400 T1440,300"
            fill="none"
            stroke="rgba(0, 217, 255, 0.06)"
            strokeWidth="2"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-thq-curve-elm7-elm curve"
        >
          <path
            d="M0,500 C240,400 480,650 720,500 S1200,350 1440,450"
            fill="none"
            stroke="rgba(0, 255, 200, 0.05)"
            strokeWidth="1.5"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-thq-curve-elm8-elm curve"
        >
          <path
            d="M1440,400 C1200,200 960,600 720,350 S240,500 0,250"
            fill="none"
            stroke="rgba(138, 0, 230, 0.04)"
            strokeWidth="2"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-thq-curve-elm9-elm curve"
        >
          <path
            d="M0,150 Q180,300 360,200 T720,350 Q900,450 1080,300 T1440,200"
            fill="none"
            stroke="rgba(255, 255, 255, 0.03)"
            strokeWidth="1"
          ></path>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-thq-accent-curve-elm-elm curve"
        >
          <path
            d="M0,250 C240,150 480,350 720,200 S1200,300 1440,150"
            fill="none"
            stroke="url(#gradient-accent1)"
            strokeWidth="2"
            strokeLinecap="round"
          >
            <animate
              dur="15s"
              values="M0,250 C240,150 480,350 720,200 S1200,300 1440,150;M0,250 C240,350 480,150 720,300 S1200,200 1440,350;M0,250 C240,150 480,350 720,200 S1200,300 1440,150"
              repeatCount="indefinite"
              attributeName="d"
            ></animate>
          </path>
          <defs>
            <linearGradient
              id="gradient-accent1"
              x1="0%"
              x2="100%"
              y1="0%"
              y2="0%"
            >
              <stop offset="0%" className="flower-icon23"></stop>
              <stop offset="50%" className="flower-icon24"></stop>
              <stop offset="100%" className="flower-icon25"></stop>
            </linearGradient>
          </defs>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-thq-accent-curve-elm2-elm curve"
        >
          <path
            d="M1440,500 C1200,400 960,600 720,450 S240,550 0,400"
            fill="none"
            stroke="url(#gradient-accent2)"
            strokeWidth="2.5"
            strokeLinecap="round"
          >
            <animate
              dur="18s"
              values="M1440,500 C1200,400 960,600 720,450 S240,550 0,400;M1440,500 C1200,600 960,400 720,550 S240,450 0,600;M1440,500 C1200,400 960,600 720,450 S240,550 0,400"
              repeatCount="indefinite"
              attributeName="d"
            ></animate>
          </path>
          <defs>
            <linearGradient
              id="gradient-accent2"
              x1="0%"
              x2="100%"
              y1="0%"
              y2="0%"
            >
              <stop offset="0%" className="flower-icon30"></stop>
              <stop offset="50%" className="flower-icon31"></stop>
              <stop offset="100%" className="flower-icon32"></stop>
            </linearGradient>
          </defs>
        </svg>
        <svg
          viewBox="0 0 1440 800"
          preserveAspectRatio="none"
          className="flower-thq-thq-accent-curve-elm3-elm curve"
        >
          <path
            d="M0,650 Q360,550 720,700 T1440,600"
            fill="none"
            stroke="url(#gradient-accent3)"
            strokeWidth="2"
            strokeLinecap="round"
            strokeDasharray="20,10,5,10"
          >
            <animate
              dur="12s"
              values="M0,650 Q360,550 720,700 T1440,600;M0,650 Q360,750 720,600 T1440,700;M0,650 Q360,550 720,700 T1440,600"
              repeatCount="indefinite"
              attributeName="d"
            ></animate>
            <animate
              dur="6s"
              values="0;45;0"
              repeatCount="indefinite"
              attributeName="stroke-dashoffset"
            ></animate>
          </path>
          <defs>
            <linearGradient
              id="gradient-accent3"
              x1="0%"
              x2="100%"
              y1="0%"
              y2="0%"
            >
              <stop offset="0%" className="flower-icon38"></stop>
              <stop offset="100%" className="flower-icon39"></stop>
            </linearGradient>
          </defs>
        </svg>
      </div>
      <Navigation></Navigation>
      <h1>DISCLAIMER: (NONE OF THESE PRODUCTS ARE FOR SALE)</h1>
      <section className="header-hero">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 1200 400"
          preserveAspectRatio="xMidYMid slice"
          className="thq-hero-curves-elm"
        >
          <path
            d="M0,200 Q300,100 600,200 T1200,200"
            fill="none"
            stroke="rgba(0,217,255,0.15)"
            strokeWidth="2"
          ></path>
          <path
            d="M0,250 Q400,150 800,250 T1200,220"
            fill="none"
            stroke="rgba(0,255,200,0.12)"
            strokeWidth="1.5"
          ></path>
          <path
            d="M0,150 Q500,250 1000,150 T1200,180"
            fill="none"
            stroke="rgba(138,0,230,0.1)"
            strokeWidth="2"
          ></path>
          <path
            d="M0,300 Q300,200 600,280 T1200,320"
            fill="none"
            stroke="rgba(0,217,255,0.08)"
            strokeWidth="1"
          ></path>
          <path
            d="M0,100 Q400,180 800,80 T1200,120"
            fill="none"
            stroke="rgba(0,255,200,0.1)"
            strokeWidth="1.5"
          ></path>
          <path
            d="M-50,350 C150,380 350,300 550,340 S850,400 1050,360 S1250,320 1350,380"
            fill="none"
            stroke="rgba(0,217,255,0.2)"
            strokeWidth="2.5"
            strokeLinecap="round"
          ></path>
          <path
            d="M-30,50 C200,20 400,80 600,40 S900,-20 1100,30 S1300,100 1350,40"
            fill="none"
            stroke="rgba(138,0,230,0.15)"
            strokeWidth="2"
            strokeLinecap="round"
          ></path>
          <path
            d="M50,180 C250,120 450,240 650,180 S950,120 1150,200"
            fill="none"
            stroke="rgba(0,255,200,0.18)"
            strokeWidth="1.8"
            strokeLinecap="round"
          ></path>
          <path
            d="M100,320 C300,280 500,360 700,300 S900,260 1100,340"
            fill="none"
            stroke="rgba(0,217,255,0.12)"
            strokeWidth="1.2"
            strokeLinecap="round"
          ></path>
          <path
            d="M200,80 C350,40 500,120 650,70 S800,20 950,90"
            fill="none"
            stroke="rgba(0,255,200,0.14)"
            strokeWidth="1.6"
            strokeLinecap="round"
          ></path>
          <path
            d="M-100,120 C200,80 500,200 800,120 S1100,60 1400,140"
            fill="none"
            stroke="rgba(0,217,255,0.85)"
            strokeWidth="6"
            strokeLinecap="round"
          ></path>
          <path
            d="M-50,280 C250,220 550,340 850,260 S1150,180 1450,280"
            fill="none"
            stroke="rgba(255,255,255,0.75)"
            strokeWidth="5"
            strokeLinecap="round"
          ></path>
          <path
            d="M0,60 C300,20 600,140 900,60 S1200,-20 1500,80"
            fill="none"
            stroke="rgba(0,255,255,0.9)"
            strokeWidth="7"
            strokeLinecap="round"
          ></path>
          <path
            d="M-80,380 C220,320 520,420 820,340 S1120,280 1420,380"
            fill="none"
            stroke="rgba(0,217,255,0.8)"
            strokeWidth="5.5"
            strokeLinecap="round"
          ></path>
          <path
            d="M50,200 C350,140 650,260 950,180 S1250,100 1550,200"
            fill="none"
            stroke="rgba(255,255,255,0.7)"
            strokeWidth="4.5"
            strokeLinecap="round"
          ></path>
          <path
            d="M-30,180 C270,100 570,240 870,160 S1170,80 1470,180"
            fill="none"
            stroke="rgba(0,255,200,0.85)"
            strokeWidth="6"
            strokeLinecap="round"
          ></path>
          <path
            d="M20,320 C320,260 620,380 920,300 S1220,220 1520,320"
            fill="none"
            stroke="rgba(0,230,255,0.75)"
            strokeWidth="5"
            strokeLinecap="round"
          ></path>
          <path
            d="M-60,160 C240,100 540,220 840,140 S1140,60 1440,160"
            fill="none"
            stroke="rgba(255,255,255,0.65)"
            strokeWidth="4"
            strokeLinecap="round"
          ></path>
        </svg>
        <div className="header-container">
          <div className="flower-container2">
            <div className="flower-thq-header-lock-icon-elm header-lock-icon"></div>
            <h1 className="hero-title">CONS MENU</h1>
          </div>
          <p className="hero-subtitle">
            <span>
              BLUEBERRY GELATO3.5-$25, 7-$35, 14-$60, Oz-$90 QP-$250, HP-$475
            </span>
            <br></br>
            <span>
              SPRINKLEZ STRAWBERRY MERINGUE PIE 3.5-$35, 7-$55, 14-$90,
              OZ-$130QP-$350, HP-$650, P-$1100
            </span>
            <br></br>
          </p>
        </div>
      </section>
      <div className="flower-thq-images-row-elm">
        <img
          alt="pastedImage"
          src="/external/pastedimage-vxfr-300h.png"
          className="flower-thq-pasted-image-elm1"
        />
        <img
          alt="pastedImage"
          src="/external/pastedimage-kpjt-300h.png"
          className="flower-thq-pasted-image-elm2"
        />
      </div>
      <section className="menu-items-list">
        <div className="menu-container">
          <div className="menu-item-row">
            <div className="menu-item-info">
              <span className="section-content">BLUEBERRY GELATO</span>
              <span className="page-status-in menu-stock-badge">In Stock</span>
            </div>
          </div>
          <div className="menu-item-row">
            <div className="menu-item-info">
              <span className="section-content">
                SPRINKLEZ STRAWBERRY MERINGUE PIE
                <span
                  dangerouslySetInnerHTML={{
                    __html: ' ',
                  }}
                />
              </span>
              <span className="page-status-in menu-stock-badge">In Stock</span>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-footer-fixed">
        <div className="page-footer-container">
          <h3 className="footer-instruction">TO ORDER MESSAGE SNAP ACCOUNTS</h3>
          <div className="flower-container3 dropdown-container">
            <button
              aria-label="Open snap accounts menu"
              aria-controls="mobile-overlay"
              aria-expanded="false"
              data-nav-toggle="true"
              data-snap-toggle="true"
              className="button snap-dropdown-btn nav-menu-toggle"
            >
              <svg
                width="20"
                xmlns="http://www.w3.org/2000/svg"
                height="20"
                viewBox="0 0 24 24"
              >
                <path
                  d="M16.882 7.842a4.882 4.882 0 0 0-9.764 0c0 4.273-.213 6.409-4.118 8.118c2 .882 2 .882 3 3c3 0 4 2 6 2s3-2 6-2c1-2.118 1-2.118 3-3c-3.906-1.709-4.118-3.845-4.118-8.118M3 15.961c4-2.118 4-4.118 1-7.118m17 7.118c-4-2.118-4-4.118-1-7.118"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <svg
                width="16"
                xmlns="http://www.w3.org/2000/svg"
                height="16"
                viewBox="0 0 24 24"
              >
                <path
                  d="m6 9l6 6l6-6"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                ></path>
              </svg>
              <span>Select Snap Account</span>
            </button>
          </div>
        </div>
      </section>
      <div>
        <div className="flower-container5">
          <Script
            html={`<style>
@keyframes float-curve {
0%, 100% {
  transform: translateX(0) scaleY(1);
}
50% {
  transform: translateX(-2%) scaleY(1.02);
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div>
        <div className="flower-container7">
          <Script
            html={`<style>
@keyframes float-curve {
0%, 100% {
  transform: translateX(0) translateY(0);
}
25% {
  transform: translateX(20px) translateY(-10px);
}
50% {
  transform: translateX(-10px) translateY(15px);
}
75% {
  transform: translateX(-20px) translateY(-5px);
}
}

@keyframes flow-pulse {
0%, 100% {
  opacity: 0.04;
  stroke-width: 1.5;
}
50% {
  opacity: 0.12;
  stroke-width: 2.5;
}
}

@keyframes gentle-wave {
0%, 100% {
  d: path("M0,400 C360,300 720,500 1080,350 S1440,450 1440,400");
}
50% {
  d: path("M0,400 C360,500 720,300 1080,450 S1440,350 1440,400");
}
}
</style>`}
          ></Script>
        </div>
      </div>
      <div>
        <div className="flower-container9">
          <Script
            html={`<style>
@keyframes flowLines {
0%, 100% {
  stroke-opacity: 0.1;
  transform: translateX(0px);
}
50% {
  stroke-opacity: 0.3;
  transform: translateX(10px);
}
}
</style>`}
          ></Script>
        </div>
      </div>
    </div>
  )
}

export default FLOWER
